import React, { useState } from "react";
import { LuMenu } from "react-icons/lu";
import { IoClose } from "react-icons/io5";
import { Link } from "react-router-dom";
import i18n from "../../Helpers/i18next";
import Select from "react-select";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import LightMode from "../LightMode/LightMode";


const Header = () => {
  const options = [
    { value: "en", label: "English" },
    { value: "ur", label: "Urdu" },
    { value: "fr", label: "France" },
    { value: "hi", label: "Hindi" },
    { value: "zh", label: "Chinees" },
    { value: "ja", label: "Japanese" },
    { value: "ko", label: "Korean" },
    { value: "de", label: "German" },
    { value: "tr", label: "Turkish" },
    { value: "es", label: "Spanish" },
    { value: "it", label: "Italian" },
    { value: "ru", label: "Russian" },
  ];
const links = [
  { label: "Home", url: "/" },
  { label: "Services", url: "/services" },
  { label: "Experties", url: "/experties" },
  { label: "Projects", url: "/projects" },
  { label: <LightMode/> },
];

  const handleLanguage2 = (selected) => {
    console.log("Selected Language:", selected.value);
    i18n.changeLanguage(selected.value);
  };

  const [menuOpen, setMenuOpen] = useState(false);

  const handleToggle = () => {
    setMenuOpen((prev) => !prev);
  };

   const {contextSafe} = useGSAP(()=>{
          const safetwen =  contextSafe(()=>{
          const TL =  gsap.timeline();
          TL.from(".logo",{
            duration: 1.3,
            delay:0.1,
            scale:1,
            y: -100,
            filter:"blur(7px)",
            opacity: 0,

          }).from(".list",{
            duration: 1.3,
            scale:0.4,
            y: 100,
            rotate:720,
            stagger:0.4,
            filter:"blur(7px)",
            opacity: 0,

          })
          gsap.from([".select",".contact"],{
            duration: 1.3,
            delay:0.1,
            scale:1,
            y: -100,
            filter:"blur(7px)",
            opacity: 0,

          })
          
            })
            safetwen()
   },[])
  return (
    <div className="bg-[#091c30] dark:bg-gradient-to-r border-b-2 border-white  dark:to-teal-400 dark:from-blue-700">
      
    <header
      style={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}
      className="flex shadow-md py-4 px-4    sm:px-10 min-h-[70px] tracking-wide relative bg-transparent z-50"
    >
      <div className="flex flex-wrap items-center justify-between gap-5 w-full">
        {/* Logo */}
        <Link className="max-sm:hidden logo" to={"/"}>
          <img src="./images/logo.png" alt="logo" className="w-36" />
        </Link>
        <Link className="hidden max-sm:block logo" to={"/"}>
          <img src="./images/logo.png" alt="logo" className="w-28" />
        </Link>

        {/* Navigation Menu */}
        <div
          className={`${
            menuOpen ? "block" : "max-lg:hidden"
          } lg:!block max-lg:before:fixed max-lg:before:bg-black max-lg:before:opacity-50 max-lg:before:inset-0 max-lg:before:z-50`}
        >
          <button
            onClick={handleToggle}
            className="lg:hidden fixed text-[#091c30] top-4 right-8 z-[100] rounded-full bg-white w-9 h-9 flex items-center justify-center border border-gray-200 cursor-pointer"
          >
            <IoClose size={30} color="#091c30" />
          </button>

          <ul className="lg:flex gap-x-4 max-lg:space-y-3 max-lg:fixed max-lg:bg-[#091c30] max-lg:w-1/2 max-lg:min-w-[300px] max-lg:top-0 max-lg:left-0 max-lg:p-6 max-lg:h-full max-lg:shadow-md max-lg:overflow-auto z-50">
            <li className="mb-6  hidden max-lg:block">
              <Link to={"/"}>
                <img src="./images/logo.png" alt="logo" className="w-36" />
              </Link>
            </li>
            {links.map((item, idx) => (
              <li
                key={idx}
                className="max-lg:border-b list max-lg:border-gray-300 max-lg:py-3 px-3"
              >
                <Link
                  to={item.url}
                  className="hover:text-[#0000ff] decoration-2 transition duration-500 hover:underline hover:underline-offset-8   text-white block font-medium text-lg"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Buttons */}
        <div className="flex max-lg:ml-auto space-x-4 items-center">
          {/* Language Select */}
          <div className="flex xl:w-80 select max-xl:w-full bg-gray-100 rounded xxs:hidden xs:block">
            <Select
              defaultValue={options[0]}
              onChange={handleLanguage2}
              options={options}
              className="w-full text-sm"
            />
          </div>

          

          {/* Contact Button */}
          <Link to="/contact" className="xxs:hidden xs:block contact">
            <button className="px-4 py-2 text-sm rounded-lg  font-medium cursor-pointer tracking-wide text-white border border-blue-500 bg-blue-800 hover:bg-blue-700 transition-all">
              Contact
            </button>
          </Link>

          {/* Menu Icon */}
          {!menuOpen && (
            <button onClick={handleToggle} className="lg:hidden cursor-pointer">
              <LuMenu size={30} color="white" />
            </button>
          )}
        </div>
      </div>
    </header>
    <div className="flex justify-between gap-3 relative z-30 px-2  py-1  xs:hidden  ">
          {/* Language Select */}
          <div className="flex l select bg-gray-100 w-full rounded">
            <Select
              defaultValue={options[0]}
              onChange={handleLanguage2}
              options={options}
              className="w-full text-sm"
            />
          </div>

          

          {/* Contact Button */}
          <div>          <Link to="/contact" className="contact">
            <button className="px-4 py-2 text-sm rounded-lg  font-medium cursor-pointer tracking-wide text-white border border-blue-500 bg-blue-800 hover:bg-blue-700 transition-all">
              Contact
            </button>
          </Link>
          </div>

        </div>
    </div>
  );
};

export default Header;
